/**
 * List of supported third party services defined by their application type.
 *
 * @type {string[]}
 */
export const SupportedThirdPartyServices = ['DAKO', 'HOS_NAM', 'TACHO_SHARE', 'TIS']
